export default __webpack_public_path__ + "static/media/mustReadBooksMS.bbdab2e7.jpg";